module.exports = __webpack_public_path__ + "static/media/vod-icon.e56197af.svg";